<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title">CONTENTS</p>
<p class="toc-entry"><a href="#/xhtml/chapter001">Wish and Vision</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter002">Faith and the Infidels</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter003" title="Link target outside of Sample">Cavernous Emotions</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter004" title="Link target outside of Sample">Motives and Mind</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter005" title="Link target outside of Sample">The Old and the Wise</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter006" title="Link target outside of Sample">Silence Is Yellow</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter007" title="Link target outside of Sample">The Rationalizers</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter008" title="Link target outside of Sample">Pax Romanitas</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter009" title="Link target outside of Sample">Daydreams and Nightmares</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter010" title="Link target outside of Sample">The Law Is Guilty</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter011" title="Link target outside of Sample">The Devil and the Skin</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter012" title="Link target outside of Sample">The Crime of Punishment</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter013" title="Link target outside of Sample">Quanta Theories</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter014" title="Link target outside of Sample">Shoddy Emotions and Shoddy Ideas</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter015" title="Link target outside of Sample">The Museum of Words</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter016" title="Link target outside of Sample">The Naked King</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter017" title="Link target outside of Sample">The Logic of Snobbism</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter018" title="Link target outside of Sample">Heart and the Mind</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter019" title="Link target outside of Sample">Brain-washing and Brain-soiling</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter020" title="Link target outside of Sample">The New Slave Society</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter021" title="Link target outside of Sample">The Sick and the Sinning</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter022" title="Link target outside of Sample">Sages and Sycophants</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter023" title="Link target outside of Sample">Science and the Good Thought</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter024" title="Link target outside of Sample">On Grading and Degrading Students</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter025" title="Link target outside of Sample">Book Knowledge and Knavery</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?eff0336a